import React from "react";
import { Navigate } from "react-router-dom";
import useUserStore from "stores/user";

type ComponentProps = {
  roles?: ("admin" | "master" | "senior_master" | "accountant")[];
  element?: React.ReactElement | null;
  isLoginPage?: boolean;
};

const ProtectedRoute = ({
  roles,
  element = null,
  isLoginPage,
}: ComponentProps) => {
  const { user } = useUserStore((store) => store);

  if (!element) return <Navigate to="/login" replace />;

  if (isLoginPage) {
    if (user.isAuthorized) {
      if (user.userData.role === "admin")
        return <Navigate to="/reference-books/stages" replace />;

      if (user.userData.role === "master")
        return <Navigate to="/schedule" replace />;

      if (user.userData.role === "senior_master")
        return <Navigate to="/schedule" replace />;

      if (user.userData.role === "accountant")
        return <Navigate to="/finance" replace />;
    }

    return element;
  }

  if (!user.isAuthorized) return <Navigate to="/login" replace />;

  if (!roles) return element;
  if (user.userData.role && roles.includes(user.userData.role)) return element;

  if (user.userData.role === "admin")
    return <Navigate to="/reference-books/stages" replace />;

  if (user.userData.role === "master")
    return <Navigate to="/schedule" replace />;

  if (user.userData.role === "senior_master")
    return <Navigate to="/schedule" replace />;

  if (user.userData.role === "accountant")
    return <Navigate to="/finance" replace />;

  return element;
};

export default ProtectedRoute;
